import dotProp from 'dot-prop-immutable';
import {
  CLEAR_ORDER_SEARCH_STATE,
  SELECT_ORDER,
  SELECT_ORDER_TASK,
  SELECT_ORDERING_SYSTEM,
  SET_SEARCH_ORDERS_QUERY,
  SELECT_SHOP_AND_CONFIG,
  SELECT_SEARCH_ORDER_SHOPS,
  SET_ORDERS,
  CLEAR_ORDERS,
  SET_SEARCH_ORDERS_ACTION,
  SHOW_ORDERS_SEARCH_ERROR,
  SET_SELECTED_ITEM,
  SET_SELECTED_NESTED_SUBITEMS,
  CLEAR_SELECTED_NESTED_SUBITEMS,
  SET_REFUNDS_COUNT,
  SET_RUTR_EVENTS,
  SET_SELECTED_RBI_ITEMS_FOR_REFUND,
  SET_RBI_APPROVED_REFUND_AMOUNT,
  SET_REFUND_AMOUNT_DETAILS,
  CLEAR_SELECTED_ITEMS,
  SET_LOADING_ORDER_ID,
  SET_SHIPPO_TRACKING_INFO,
  SET_SEARCH_TYPE,
  SET_RETURN_LABEL_LINK,
  SET_RETURN_SHIPMENT_TRACKING_NUMBER,
  SET_RETURN_SHIPMENT_CARRIER,
  SET_RETURN_ITEMS,
  SET_REFUND_AMOUNT,
  SET_REFUND_AMOUNT_FORMATTED,
  SET_RBI_CUSTOMER_ID,
  SET_RBI_CUSTOMER_BIRTHDAY,
  SET_RBI_LOYALTY_ID,
  SET_RBI_COUPONS_INFO,
  SET_STORE_CREDIT_AMOUNT,
  SET_CANCELED_ITEMS,
  SET_SHOW_CONFIRMATION_PAGE,
  RESET_SHOW_CONFIRMATION_PAGE,
  SET_SUBSCRIPTION_FREQUENCY,
  SET_DISCOUNT_PERIODS,
  SET_ITEM_AND_DISCOUNT_PERIOD_MATCHES,
  SET_SELECTED_DISCOUNT_PERIOD,
  SET_SELECTED_COUPON_CODE_TYPE,
  SET_REFUNDS_ON_SHOPIFY_ORDER,
  SELECT_SHOP_NAME,
  SET_RETURN_NOTE,
  SET_ORDER_TOTAL,
  SET_RETURN_ORDER_ITEMS,
  SET_RETURN_REASON,
  SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION,
  SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS,
  SET_CURRENCY_CODE,
  UPDATE_SELECTED_ORDER,
  ADD_CANCEL_AND_REFUND_ITEM,
  ADD_REFUND_ONLY_ITEM,
  ADD_CANCEL_ONLY_ITEM,
  ADD_DISCOUNT_ONLY_ITEM,
  CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS,
  SET_ACTION_REASONS,
  SELECT_MULTI_DOMAIN,
  SELECT_SIMPLR_ORDER_MULTI_DOMAIN,
  SET_CUSTOMER_GROUPS,
  SET_SELECTED_CUSTOMER_GROUP_ID,
  SET_REFUND_SHIPPING_AMOUNT,
  SET_ORDER_SEARCH,
  ADD_EXTRA_LASTMILE_INFO,
  CLEAR_EXTRA_LASTMILE_INFO,
  SET_ORDER_SHIPPING_ADDRESS,
  SET_SHOPIFY_ORDER_SHIPPING_ADDRESS,
  SET_NUMBER_SUPPORT_TRANSACTIONS,
  SET_SELECTED_ALL_ITEMS,
  SET_SELECTED_ITEMS_QUANTITY,
  SET_ADDITIONAL_ORDER_DETAILS,
  SET_RBI_ASSIGNED_OFFERS,
  SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER,
  SET_SELECTED_PRODUCT,
  SET_PRODUCTS_LIST,
  SET_ORDER_TAGS,
  SET_DYNAMIC_ORDER_SEARCH_VALUE,
  SET_SELECTED_RBI_ITEMS_FOR_COUPON,
  SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS,
  SET_INVALID_SNIPPET_DATA,
  CLEAR_INVALID_SNIPPET_DATA,
} from '../../constants/ordersSearchActionTypes';

const cleanSearchState = {
  selectedSearchAction: null,
  selectedSearchQuery: null,
};

const cleanTaskOrderState = {
  returnShipmentCarrier: null,
  selectedReturnLabelLink: null,
  returnShipmentTrackingNumber: null,
  selectedOrder: null,
  lastOrderInSelectedSubscription: null,
  loadingOrderId: null,
  selectedTask: null,
  searchError: null,
  shippoTrackingInfoByShipmentId: {},
  refundAmount: '0.00',
  orderTotal: '0.00',
  refundShippingAmount: '0.00',
  currencyCode: '',
  amazonOrderWarrantyTotalYears: null,
  storeCreditAmount: '0.00',
  subscriptionFrequency: {},
  returnedItems: [],
  canceledItems: [],
  cancelAndRefundItems: [],
  refundOnlyItems: [],
  cancelOnlyItems: [],
  discountOnlyItems: [],
  discountPeriods: [],
  selectedDiscountPeriod: null,
  selectedCouponCodeType: null,
  itemAndDiscountPeriodMatches: {},
  showConfirmationPagePaths: [],
  actionReasons: null,
  customerGroups: {},
  additionalOrderDetails: {},
  dynamicOrderSearchValues: {},
  invalidSnippetData: [], // Chegg Specific
};

export const defaultState = {
  orderingSystem: null,
  selectedShop: null,
  selectedConfig: null,
  selectedMultiDomain: null,
  orders: [],
  products: [],
  selectedProduct: {},
  selectedItems: {},
  selectedItemsQuantity: {},
  selectedNestedSubItems: {}, // RBI specific
  selectedRbiItemsForRefund: [], // RBI specific
  selectedRbiItemsForCoupon: [], // RBI specific
  selectedRbiItemsForLoyaltyPoints: [], // RBI specific
  rbiRefundsCount: {}, // RBI specific
  rbiRutrEvents: [], // RBI specific
  rbiCouponsInfo: {}, // RBI specific
  rbiCustomerId: null,
  chegg: {
    // Chegg-specific, do not copy
    selectedBookIssuesOrder: {},
  },
  refundAmountDetails: {},
  extraLastMileInfo: {},
  numberCustomerSupportTransactions: null,
  ...cleanSearchState,
  ...cleanTaskOrderState,
  invalidSnippetData: [], // Chegg Specific
};

const ordersSearch = (state = defaultState, action) => {
  switch (action.type) {
    case SELECT_MULTI_DOMAIN:
      return { ...state, selectedMultiDomain: action.payload };
    case SELECT_SIMPLR_ORDER_MULTI_DOMAIN:
      return { ...state, selectedSimplrOrderDomains: action.payload };
    case SELECT_ORDERING_SYSTEM:
      return Object.assign({}, state, {
        orderingSystem: action.orderingSystem,
        // TODO: Uncomment when we'll have ordering system selection UI (before shop selection)
        // selectedShop: null,
        // selectedConfig: null,
        // selectedSearchAction: null,
        // orders: [], // See Anastasia question and Ivan answer in _integrations_mev channel on 18-09-2018
        ...cleanTaskOrderState,
      });
    case SELECT_SEARCH_ORDER_SHOPS:
      return Object.assign({}, state, {
        searchOrderShops: action.searchOrderShops,
        searchOrderZendeskConfig: action.searchOrderZendeskConfig,
      });
    case SELECT_SHOP_AND_CONFIG:
      return Object.assign({}, state, {
        selectedShop: action.shop,
        selectedConfig: action.config,
        selectedSearchAction: null,
        orders: [],
        ...cleanTaskOrderState,
      });
    case SELECT_SHOP_NAME:
      return dotProp.set(state, 'selectedShop', action.shopName);
    case SET_SELECTED_COUPON_CODE_TYPE:
      return dotProp.set(state, 'selectedCouponCodeType', action.couponType);
    case SET_SEARCH_ORDERS_ACTION:
      return Object.assign({}, state, {
        selectedSearchAction: action.action,
        selectedSearchQuery: null,
        orders: [],
        ...cleanTaskOrderState,
      });
    case SET_ORDERS:
      return Object.assign({}, state, {
        orders: action.orders,
        searchError: null,
      });
    case CLEAR_ORDERS:
      return Object.assign({}, state, {
        orders: [],
        selectedOrder: {},
        selectedItems: {},
        selectedItemsQuantity: {},
        selectedNestedSubItems: {},
        selectedRbiItemsForRefund: [],
        selectedRbiItemsForCoupon: [],
        selectedRbiItemsForLoyaltyPoints: [],
        refundAmountDetails: {},
        rbiRefundsCount: {},
        rbiRutrEvents: [],
        searchError: null,
        actionReasons: null,
        rbiCustomerId: null,
        rbiCouponsInfo: {},
        showConfirmationPagePaths: [],
        loadingOrderId: null,
        shippoTrackingInfoByShipmentId: {},
        invalidSnippetData: [], // Chegg Specific
      });
    case SELECT_ORDER:
      return Object.assign({}, state, {
        selectedOrder: action.order,
        selectedItems: {},
        selectedItemsQuantity: {},
        selectedNestedSubItems: {},
        selectedRbiItemsForRefund: [],
        selectedRbiItemsForCoupon: [],
        selectedRbiItemsForLoyaltyPoints: [],
        refundAmountDetails: {},
        searchError: null,
        selectedTask: null,
      });
    case UPDATE_SELECTED_ORDER:
      // TODO this looks strange... needs to be checked
      return Object.assign({}, state, {
        selectedOrder: { ...state.selectedOrder, ...action.order },
      });
    case SET_LOADING_ORDER_ID:
      return dotProp.set(state, 'loadingOrderId', action.order_id);
    case SELECT_ORDER_TASK:
      return Object.assign({}, state, {
        selectedTask: action.task,
      });
    case SET_LAST_ORDER_IN_SELECTED_SUBBSCRIPTION:
      return Object.assign({}, state, {
        lastOrderInSelectedSubscription: action.lastOrderInSelectedSubscription,
      });
    case SHOW_ORDERS_SEARCH_ERROR:
      return Object.assign({}, state, {
        searchError: action.error,
      });
    case SET_RETURN_LABEL_LINK:
      return Object.assign({}, state, {
        selectedReturnLabelLink: action.link,
      });
    case SET_RETURN_SHIPMENT_TRACKING_NUMBER:
      return Object.assign({}, state, {
        returnShipmentTrackingNumber: action.number,
      });
    case SET_RETURN_SHIPMENT_CARRIER:
      return Object.assign({}, state, {
        returnShipmentCarrier: action.carrier,
      });
    case SET_ORDER_TOTAL:
      return Object.assign({}, state, {
        orderTotal: action.orderTotal,
      });
    case SET_REFUND_AMOUNT:
      return Object.assign({}, state, {
        refundAmount: action.amount,
      });
    case SET_REFUND_AMOUNT_FORMATTED:
      return Object.assign({}, state, {
        refundAmountFormatted: action.amount,
      });
    case SET_REFUND_SHIPPING_AMOUNT:
      return {
        ...state,
        refundShippingAmount: action.amount,
      };
    case SET_AMAZON_ORDER_WARRANTY_TOTAL_YEARS:
      return Object.assign({}, state, {
        amazonOrderWarrantyTotalYears: action.totalYears,
      });
    case SET_CURRENCY_CODE:
      return Object.assign({}, state, {
        currencyCode: action.currencyCode,
      });
    case ADD_CANCEL_AND_REFUND_ITEM:
      return dotProp.set(state, 'cancelAndRefundItems', [...state.cancelAndRefundItems, action.item]);
    case ADD_REFUND_ONLY_ITEM:
      return dotProp.set(state, 'refundOnlyItems', [...state.refundOnlyItems, action.item]);
    case ADD_CANCEL_ONLY_ITEM:
      return dotProp.set(state, 'cancelOnlyItems', [...state.cancelOnlyItems, action.item]);
    case ADD_DISCOUNT_ONLY_ITEM:
      return dotProp.set(state, 'discountOnlyItems', [...state.discountOnlyItems, action.item]);
    case CLEAR_CANCEL_REFUND_DISCOUNT_TREE_ITEMS:
      return Object.assign({}, state, {
        refundOnlyItems: [],
        cancelOnlyItems: [],
        cancelAndRefundItems: [],
        discountOnlyItems: [],
      });
    case SET_SUBSCRIPTION_FREQUENCY:
      return dotProp.set(state, `subscriptionFrequencies.${action.id}.${action.field}`, action.value);
    case SET_STORE_CREDIT_AMOUNT:
      return Object.assign({}, state, {
        storeCreditAmount: action.amount,
      });
    case SET_RETURN_ITEMS:
      return Object.assign({}, state, {
        returnedItems: action.items,
      });
    case SET_CANCELED_ITEMS:
      return Object.assign({}, state, {
        canceledItems: action.items,
      });
    case RESET_SHOW_CONFIRMATION_PAGE:
      return dotProp.set(state, 'showConfirmationPagePaths', []);
    case SET_SHOW_CONFIRMATION_PAGE:
      return dotProp.set(state, 'showConfirmationPagePaths', [...state.showConfirmationPagePaths, action.path]);
    case CLEAR_ORDER_SEARCH_STATE:
      return Object.assign({}, defaultState);
    case SET_ORDER_SEARCH:
      return Object.assign({}, defaultState, action.data);
    case SET_SELECTED_ITEM:
      return dotProp.set(state, `selectedItems.${action.itemId}`, action.value);
    case SET_SELECTED_ALL_ITEMS:
      const selectedItems = Object.assign({}, ...action.items.map((itemId) => ({ [itemId]: true })));

      return dotProp.set(state, 'selectedItems', selectedItems);
    case SET_SELECTED_ITEMS_QUANTITY:
      return dotProp.set(state, `selectedItemsQuantity.${action.itemId}`, action.quantity);
    case SET_SELECTED_NESTED_SUBITEMS:
      return dotProp.set(state, `selectedNestedSubItems.${action.itemId}`, action.selectedNestedSubItemsIds);
    case CLEAR_SELECTED_NESTED_SUBITEMS:
      return dotProp.set(state, `selectedNestedSubItems.${action.itemId}`, []);
    case SET_REFUNDS_COUNT:
      return dotProp.set(state, `rbiRefundsCount`, action.refundsCountObj);
    case SET_RUTR_EVENTS:
      return dotProp.set(state, `rbiRutrEvents`, action.rutrEvents);
    case SET_SELECTED_RBI_ITEMS_FOR_REFUND:
      return dotProp.set(state, `selectedRbiItemsForRefund`, action.selectedRbiItemsForRefund);
    case SET_SELECTED_RBI_ITEMS_FOR_COUPON:
      return dotProp.set(state, `selectedRbiItemsForCoupon`, action.selectedRbiItemsForCoupon);
    case SET_SELECTED_RBI_ITEMS_FOR_LOYALTY_POINTS:
      return dotProp.set(state, `selectedRbiItemsForLoyaltyPoints`, action.selectedRbiItemsForLoyaltyPoints);
    case SET_RBI_APPROVED_REFUND_AMOUNT:
      return dotProp.set(state, `refundAmountDetails.approvedAmountCents`, action.amount);
    case SET_RBI_CUSTOMER_ID:
      return dotProp.set(state, `rbiCustomerId`, action.customerId);
    case SET_RBI_CUSTOMER_BIRTHDAY:
      return dotProp.set(state, 'rbiCustomerBirthday', action.rbiCustomerBirthday);
    case SET_RBI_LOYALTY_ID:
      return dotProp.set(state, `rbiLoyaltyId`, action.loyaltyId);
    case SET_RBI_COUPONS_INFO:
      return dotProp.set(state, `rbiCouponsInfo`, action.rbiCouponsInfo);
    case SET_RBI_ASSIGNED_OFFERS:
      return dotProp.set(state, `rbiAssignedOffers`, action.rbiAssignedOffers);
    case SET_SELECTED_CHEGG_BOOK_ISSUES_ORDER:
      return dotProp.set(state, 'chegg.selectedBookIssuesOrder', action.selectedCheggBookIssuesOrder);
    case SET_NUMBER_SUPPORT_TRANSACTIONS:
      return dotProp.set(state, 'numberCustomerSupportTransactions', action.numberCustomerSupportTransactions);
    case SET_REFUND_AMOUNT_DETAILS:
      return dotProp.set(state, `refundAmountDetails`, action.refundAmountDetails);
    case CLEAR_SELECTED_ITEMS:
      return dotProp.set(state, 'selectedItems', {});
    case SET_SHIPPO_TRACKING_INFO:
      return dotProp.set(state, `shippoTrackingInfoByShipmentId.${action.shipmentId}`, action.shippoTracking);
    case SET_SEARCH_ORDERS_QUERY:
      return dotProp.set(state, 'selectedSearchQuery', action.query);
    case SET_DISCOUNT_PERIODS:
      return dotProp.set(state, 'discountPeriods', action.discountPeriods);
    case SET_RETURN_ORDER_ITEMS:
      return dotProp.set(state, 'returnOrderItems', action.returnOrderItems);
    case SET_RETURN_REASON:
      return dotProp.set(state, 'returnReason', action.returnReason);
    case SET_ACTION_REASONS:
      return dotProp.set(state, 'actionReasons', action.actionReasons);
    case SET_RETURN_NOTE:
      return dotProp.set(state, 'returnNote', action.returnNote);
    case SET_ITEM_AND_DISCOUNT_PERIOD_MATCHES:
      return dotProp.set(state, 'itemAndDiscountPeriodMatches', action.itemAndDiscountPeriodMatches);
    case SET_SELECTED_DISCOUNT_PERIOD:
      return dotProp.set(state, 'selectedDiscountPeriod', action.selectedDiscountPeriod);
    case SET_SEARCH_TYPE:
      // reset the search terms/type when switching the top level search type
      return Object.assign({}, state, cleanSearchState);
    case SET_REFUNDS_ON_SHOPIFY_ORDER:
      return dotProp.set(state, 'selectedOrder.refunds', action.refunds);
    case SET_CUSTOMER_GROUPS:
      return dotProp.set(state, 'customerGroups.groups', action.groups);
    case SET_SELECTED_CUSTOMER_GROUP_ID:
      return dotProp.set(state, 'customerGroups.selectedCustomerGroupId', action.customerGroupId);
    case ADD_EXTRA_LASTMILE_INFO:
      return dotProp.set(state, 'extraLastMileInfo', action.extraLastMileInfo);
    case CLEAR_EXTRA_LASTMILE_INFO:
      return dotProp.set(state, 'extraLastMileInfo', {});
    case SET_ORDER_SHIPPING_ADDRESS:
      return dotProp.set(state, 'selectedOrder.shippingAddress', action.payload);
    case SET_SHOPIFY_ORDER_SHIPPING_ADDRESS:
      return dotProp.set(state, 'selectedOrder.shipping_address', action.payload);
    case SET_ADDITIONAL_ORDER_DETAILS:
      return dotProp.set(state, 'selectedOrder.additionalOrderDetails', action.additionalOrderDetails);
    case SET_SELECTED_PRODUCT:
      return dotProp.set(state, 'selectedProduct', action.selectedProduct);
    case SET_PRODUCTS_LIST:
      return dotProp.set(state, 'products', action.productsList);
    case SET_ORDER_TAGS:
      return dotProp.set(state, 'orderTags', action.orderTags);
    case SET_DYNAMIC_ORDER_SEARCH_VALUE:
      return dotProp.set(state, `dynamicOrderSearchValues.${action.paramName}`, action.paramValue);
    case SET_INVALID_SNIPPET_DATA:
      return dotProp.set(state, 'invalidSnippetData', action.invalidSnippetData);
    case CLEAR_INVALID_SNIPPET_DATA:
      return dotProp.set(state, 'invalidSnippetData', []);
    default:
      return state;
  }
};

export default ordersSearch;
